import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const LikeIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        opacity="0.2"
        d="M0 4.20634C0 2.09467 1.61676 0.382812 3.61111 0.382812C4.79239 0.382812 5.84117 0.983366 6.5 1.91185C7.15883 0.983366 8.20761 0.382812 9.38889 0.382812C11.3832 0.382812 13 2.09467 13 4.20634C13 7.61462 8.42796 10.0863 6.5 12.3828C4.57204 10.0863 0 7.61462 0 4.20634Z"
        fill={fillColor || '#2A2C2D'}
      />
    </svg>
  );
};

export { LikeIcon };
